import { upsertRole } from '@dispatch/shared/services';
import { RoleUpsertBody } from '@dispatch/shared/types';
import { useMutation, useQueryClient } from 'react-query';

export const useUpsertRole = (roleId: string, onSuccess: () => void) => {
  const client = useQueryClient();
  const { mutate, error, status } = useMutation(
    ['upsert-role', roleId],
    async (data: RoleUpsertBody) => upsertRole(data),
    {
      onSuccess,
      onSettled: () => {
        if (roleId) {
          client.invalidateQueries(['role', roleId]);
          client.invalidateQueries('role');
        }
      },
    }
  );

  return {
    upsertRole: mutate,
    error,
    status,
  };
};
